import SosService from "@/services/SosService";
import store from "@/store";
import cookie from 'cookiejs';

const sos = {
    state: () => ({
        SOSBANNER: null,
        SOSSHOW: null,
        SOSDATA: null
    }),
    getters: {
        SOSBANNER: (state) => {
            return state.SOSBANNER != null ? state.SOSBANNER : []
        },
        SOSSHOW: (state) => {
            return state.SOSSHOW != null ? state.SOSSHOW : {}
        },
        SOSDATA: (state) => {
            return state.SOSDATA != null ? state.SOSDATA : {}
        }
    },
    mutations: {
        SOS_BANNER: (state, data) => {
            state.SOSBANNER = data;
        },
        SOS_SHOW: (state, data) => {
            state.SOSSHOW = data;
        },
        SOS_DATA: (state, data) => {
            state.SOSDATA = data;
        }
    },
    actions: {
        SosBannerCall: async ({ commit }, json) => {
            const response = await SosService.SosBannerApi(json);
            if (response.status === false) {
                cookie.remove('logKey');
                location.reload();
            } else {
                commit("SOS_BANNER", response);
            }
        },
        SosCallList: async ({ commit }, json) => {
            const response = await SosService.SosAdminApi(json);
            if (response.status === false) {
                cookie.remove('logKey');
                location.reload();
            } else {
                commit("SOS_SHOW", response);
            }
        },
        SosDataSubmit: async ({ commit }, json) => {
            const response = await SosService.SosAdminApi(json);
            if (response.status === false) {
                cookie.remove('logKey');
                location.reload();
            } else {
                commit("SOS_DATA", response);
            }
        },
    }
}

export default sos;